import { ProgramBuilderMainComponent } from './modules/creation-center/components/program-builder-main/program-builder-main.component';
import { ProgramPageComponent } from './modules/learning-center/components/program-page/program-page.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CarouselModule } from 'ngx-owl-carousel-o';
import 'hammerjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MyProgramsComponent } from './modules/obsolete/components/my-programs/my-programs.component';
import { HistoryComponent } from './modules/learning-center/components/history/history.component';
import { AuthComponent } from './modules/auth/components/auth/auth.component';
import { MaterialModule } from './material.module';
import { AuthModule } from './modules/auth/components/auth/auth.module';
// import { MatIconModule } from '@angular/material/icon'
// import { SwiperModule } from 'swiper/angular';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

// import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HeaderComponent } from './shared/components/header/header.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgImageSliderModule } from 'ng-image-slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SwiperModule } from 'swiper/angular';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
import { connectFirestoreEmulator, provideFirestore, getFirestore } from '@angular/fire/firestore';
import { OrganizationComponent } from './modules/obsolete/components/organization/organization.component';
import { connectStorageEmulator, provideStorage, getStorage } from '@angular/fire/storage';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireFunctionsModule, USE_EMULATOR as USE_FUNCTIONS_EMULATOR } from '@angular/fire/compat/functions';

import { MatNativeDateModule } from '@angular/material/core';

// import { TabsModule } from 'ngx-bootstrap/tabs';
import { EditOrganizationComponent } from './modules/obsolete/components/organization/components/edit-organization/edit-organization.component';
import { AlertComponent } from './shared/modals/alert/alert.component';
import { SuccessComponent } from './shared/modals/success/success.component';
import { GroupComponent } from './modules/obsolete/components/group/group.component';
import { EditGroupComponent } from './modules/obsolete/components/group/components/edit-group/edit-group.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SidemenuComponent } from './shared/components/sidemenu/sidemenu.component';
import { NgMaterialMultilevelMenuModule, MultilevelMenuService } from 'ng-material-multilevel-menu';
import { MyLearningComponent } from './modules/obsolete/components/my-learning/my-learning.component';
import { MyLibraryComponent } from './modules/learning-center/components/my-library/my-library.component';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { AnalyticsComponent } from './modules/analytics/components/analytics/analytics.component';
import { MyDashboardComponent } from './modules/learning-center/components/my-dashboard/my-dashboard.component';
import { ReportsComponent } from './modules/obsolete/components/reports/reports.component';
import { OrderByPipe } from './shared/pipes/order-by-pipe';
import { RemoveBreakTagPipePipe } from './shared/pipes/remove-break-tag-pipe.pipe';
import { AchieveProgramDataComponent } from './modules/obsolete/components/achieve-program-data/achieve-program-data.component';
import { ManagementComponent } from './modules/management/management.component';
// import { NgChartsModule } from 'ng2-charts';
import { NgChartsModule } from 'ng2-charts'
import { RewardsComponent } from './modules/rewards/components/rewards/rewards.component';
import { AuditBuilderComponent } from './modules/creation-center/components/audit-builder/audit-builder.component';
import { AuditVisitationComponent } from './modules/store-visitation/components/audit-visitation/audit-visitation.component';
// import bootstrapi
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { AuditVisitationBuilderComponent } from './modules/store-visitation/components/audit-visitation-builder/audit-visitation-builder.component';
// import { AccordionModule } from '@coreui/angular';
import { MdbAccordionModule } from 'mdb-angular-ui-kit/accordion';
import { MdbCarouselModule } from 'mdb-angular-ui-kit/carousel';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { MdbCollapseModule } from 'mdb-angular-ui-kit/collapse';
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbModalModule } from 'mdb-angular-ui-kit/modal';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { MdbRadioModule } from 'mdb-angular-ui-kit/radio';
import { MdbRangeModule } from 'mdb-angular-ui-kit/range';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { MdbScrollspyModule } from 'mdb-angular-ui-kit/scrollspy';
import { MdbTooltipModule } from 'mdb-angular-ui-kit/tooltip';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
// import { SingleMediaPlayer } from './single-media-player';
import { MatSliderModule } from '@angular/material/slider';
import { IgxCalendarModule } from 'igniteui-angular';
import { SortNamePipe } from './shared/pipes/sort-name.pipe';
// import { SwiperComponent, SwiperModule } from "swiper/angular";
// import { DoughnutChartComponent, PieChartComponent, BarChartComponent } from 'angular-d3-charts'
import {
  IgxAccordionModule,
  IgxExpansionPanelModule,
  IgxSwitchModule
} from "igniteui-angular";
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { ChangeFilterPageComponent } from './modules/obsolete/components/change-filter-page/change-filter-page.component';
import { NgApexchartsModule } from 'ng-apexcharts';

var CanvasJSChart = CanvasJSAngularChart.CanvasJSChart;
import * as CanvasJSAngularChart from '../assets/canvasjs-3.7.5/canvasjs.angular.component'
import { ChartsModule } from '@progress/kendo-angular-charts';

// import {NgApexchartsModule} from 'ng-ape'
import { TabsComponent } from './modules/management/components/tabs/tabs.component';
import { UsersComponent } from './modules/management/components/tabs/components/users/users.component';
import { AdminChangePasswordDialogComponent } from './modules/management/components/tabs/components/users/admin-change-password-dialog/admin-change-password-dialog.component';
import { UserEditComponent } from './modules/management/components/tabs/components/users/user-edit/user-edit.component';
import { EditOrganisationComponent } from './modules/management/modals/edit-organisation/edit-organisation.component';
import { SettingsComponent } from './modules/management/components/tabs/components/settings/settings.component';
// import { Chart } from 'chart.js';
import { NgxSpinnerModule } from "ngx-spinner";
import { ConfirmationDialogComponent } from './shared/modals/confirmation-dialog/confirmation-dialog.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CreateOrganisationHierarchyComponent } from './modules/management/components/tabs/components/create-organisation-hierarchy/create-organisation-hierarchy.component';
import { ProgramsSidenavIgxComponent } from './modules/learning-center/components/programs-sidenav-igx/programs-sidenav-igx.component';
import { HierarchyCheckboxesComponent } from './modules/management/components/tabs/components/hierarchy-checkboxes/hierarchy-checkboxes.component';
import { ProfilePageComponent } from './modules/profile/components/profile-page/profile-page.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SelectPhotoModalComponent } from './modules/profile/modals/select-photo-modal/select-photo-modal.component';
import { WebcamModule } from 'ngx-webcam';
import { WebcamComponentComponent } from './modules/profile/modals/webcam-component/webcam-component.component';
import { VgMuteExtendedComponent } from './modules/learning-center/components/program-page/vg-mute-extended';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { ClickOutsideDirective } from './shared/directives/click-outside.directive';
import { AnalyticsMainComponent } from './modules/analytics/components/analytics-main/analytics-main.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { SafePipe } from './shared/pipes/safe.pipe';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { connectAuthEmulator, getAuth, provideAuth } from '@angular/fire/auth';
import { SocialMediaCarouselComponent } from './modules/learning-center/components/my-dashboard/social-media-carousel/social-media-carousel.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
// import { CarouselModule } from 'ngx-owl-carousel-o';
import { MobileHistoryPageComponent } from './modules/learning-center/components/history/mobile-history-page/mobile-history-page.component';
import { IframeAutoHeightDirective } from './shared/directives/iframe-auto-height.directive';
import { MatSortModule } from '@angular/material/sort';
import { SharedModule } from './shared/shared.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ForgotPasswordComponent } from './modules/auth/components/forgot-password/forgot-password.component';
import { ForgotPasswordModule } from './modules/auth/components/forgot-password/forgot-password.module';
import { HelpSupportModalComponent } from './modules/help-and-support/modals/help-support-modal/help-support-modal.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { IntroVideoModalComponent } from './shared/modals/intro-video-modal/intro-video-modal.component';
import { MobileInfoModalComponent } from './shared/modals/mobile-info-modal/mobile-info-modal.component';
import { AccessProgramComponent } from './modules/management/modals/access-program/access-program.component';
import { StepInstallIosModalComponent } from './shared/modals/step-install-ios-modal/step-install-ios-modal.component';
import { MiniclipsModalComponent } from './modules/learning-center/modals/miniclips-modal/miniclips-modal.component';
import { VideoModalComponent } from './shared/modals/video-modal/video-modal.component';
import { ProgramAccessByRolesComponent } from './modules/management/components/tabs/components/program-access-by-roles/program-access-by-roles.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MyLibraryModule } from './modules/learning-center/components/my-library/my-library.module';
import { CustomPipComponent } from './modules/learning-center/components/my-dashboard/custom-pip/custom-pip.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
// import { TimeFormatPipe } from './shared/pipes/time-format.pipe';
// import { CarouselModule } from 'ngx-owl-carousel-o';
// import

// import { PdfViewerModule } from 'ng2-pdf-viewer';
// import { Ng5SliderModule } from 'ng5-slider';
// import angularfire
@NgModule({
  declarations: [
    AppComponent,
    ClickOutsideDirective,
    IframeAutoHeightDirective,
    MyProgramsComponent,
    HistoryComponent,
    AuthComponent,
    HeaderComponent,
    OrganizationComponent,
    EditOrganizationComponent,
    AlertComponent,
    SuccessComponent,
    GroupComponent,
    EditGroupComponent,
    SidemenuComponent,
    MyLearningComponent,
    MyLibraryComponent,
    MyDashboardComponent,
    ReportsComponent,
    OrderByPipe,
    RemoveBreakTagPipePipe,
    AchieveProgramDataComponent,
    ManagementComponent,
    RewardsComponent,
    AuditBuilderComponent,
    AuditVisitationComponent,
    AuditVisitationBuilderComponent,
    AnalyticsComponent,
    ChangeFilterPageComponent,
    CanvasJSChart,
    ManagementComponent,
    TabsComponent,
    UsersComponent,
    AdminChangePasswordDialogComponent,
    UserEditComponent,
    EditOrganisationComponent,
    SettingsComponent,
    ConfirmationDialogComponent,
    CreateOrganisationHierarchyComponent,
    ProgramPageComponent,
    ProgramsSidenavIgxComponent,
    HierarchyCheckboxesComponent,
    ProfilePageComponent,
    SelectPhotoModalComponent,
    WebcamComponentComponent,
    VgMuteExtendedComponent,
    AnalyticsMainComponent,
    ProgramBuilderMainComponent,
    SocialMediaCarouselComponent,
    SafePipe,
    MobileHistoryPageComponent,
    SortNamePipe,
    ForgotPasswordComponent,
    IntroVideoModalComponent,
    HelpSupportModalComponent,
    MobileInfoModalComponent,
    StepInstallIosModalComponent,
    MiniclipsModalComponent,
    VideoModalComponent,
    AccessProgramComponent,
    ProgramAccessByRolesComponent,
    CustomPipComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    AuthModule,
    NgxChartsModule,
    CarouselModule,
    NgImageSliderModule,
    MatSlideToggleModule,
    NgbCarouselModule,
    MatDialogModule,
    NgbModule,
    MatIconModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    MatNativeDateModule,
    NgMaterialMultilevelMenuModule,
    NgChartsModule,
    NgxSpinnerModule,
    MdbTabsModule,
    NgbAccordionModule,
    CdkAccordionModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    FormlyModule,
    FormlyMaterialModule,
    NgApexchartsModule,
    // AccordionModule,
    FontAwesomeModule,
    MatSnackBarModule,
    SlickCarouselModule,
    MatSliderModule,
    WebcamModule,
    MatFormFieldModule,
    MatInputModule,
    // Ng5SliderModule,
    NgxSliderModule,
    IgxCalendarModule,
    SharedModule,
    MatExpansionModule,
    ForgotPasswordModule,
    // PdfViewerModule,
    MyLibraryModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 22,
      innerStrokeWidth: 10,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
      space: -15,
      backgroundStrokeWidth: 0,
      outerStrokeLinecap: "round"
    }),
    MdbAccordionModule,
    MdbCarouselModule,
    MdbCheckboxModule,
    MdbCollapseModule,
    MdbDropdownModule,
    MdbFormsModule,
    MdbModalModule,
    MdbPopoverModule,
    MdbRadioModule,
    MdbRangeModule,
    MdbRippleModule,
    MdbScrollspyModule,
    MdbTooltipModule,
    MdbValidationModule,
    IgxAccordionModule,
    IgxSwitchModule,
    ChartsModule,
    IgxExpansionPanelModule,
    Ng2SearchPipeModule,
    MatSortModule,
    PerfectScrollbarModule,
    DragDropModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireFunctionsModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => {
      const firestore = getFirestore();
      if (environment.useEmulators && environment.emulators.firestore.enabled) {
        connectFirestoreEmulator(
          firestore,
          environment.emulators.firestore.host,
          environment.emulators.firestore.port
        );
        console.info(
          `[Firebase Emulator] Firestore: ${environment.emulators.firestore.host}:${environment.emulators.firestore.port}`
        );
      }
      return firestore;
    }),
    provideAuth(() => {
      const auth = getAuth();
      if (environment.useEmulators && environment.emulators.auth.enabled) {
        connectAuthEmulator(auth, environment.emulators.auth.url, { disableWarnings: true });
        console.info(`[Firebase Emulator] Auth: ${environment.emulators.auth.url}`);
      }
      return auth;
    }),
    provideStorage(() => {
      const storage = getStorage();
      if (environment.useEmulators && environment.emulators.storage.enabled) {
        connectStorageEmulator(
          storage,
          environment.emulators.storage.host,
          environment.emulators.storage.port
        );
        console.info(
          `[Firebase Emulator] Storage: ${environment.emulators.storage.host}:${environment.emulators.storage.port}`
        );
      }
      return storage;
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    MultilevelMenuService,
    ...(environment.useEmulators && environment.emulators.functions.enabled ? [{
      provide: USE_FUNCTIONS_EMULATOR,
      useValue: [environment.emulators.functions.host, environment.emulators.functions.port]
    }] : [])
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
